import BaseParser from './BaseParser';
import _get from 'lodash/get';

class Coding extends BaseParser {
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.Coding) {
    if (!fhirProperty) return null;

    const code = _get(fhirProperty, 'code', null);
    const display = _get(fhirProperty, 'display', null);
    return display || code;
  }
}

export default Coding;
